import { StyleProp, ViewStyle } from 'react-native';
import Svg, { Path } from 'react-native-svg';
import { nativewindWrapSvg } from './wrapSvg';

const ShowIconRaw = ({
  style,
  stroke,
  className,
}: {
  style?: StyleProp<ViewStyle>;
  stroke?: string;
  className?: string;
}) => {
  return (
    <Svg width={24} height={24} viewBox="0 0 25 24" fill="none" style={style}>
      <Path
        d="M3.57626 11.9545C3.57626 11.9545 6.84899 5.40909 12.5763 5.40909C18.3035 5.40909 21.5763 11.9545 21.5763 11.9545C21.5763 11.9545 18.3035 18.5 12.5763 18.5C6.84899 18.5 3.57626 11.9545 3.57626 11.9545Z"
        stroke={stroke}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M12.5777 14.3158C13.9333 14.3158 15.0322 13.2585 15.0322 11.9543C15.0322 10.65 13.9333 9.59269 12.5777 9.59269C11.2221 9.59269 10.1231 10.65 10.1231 11.9543C10.1231 13.2585 11.2221 14.3158 12.5777 14.3158Z"
        stroke={stroke}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
};

export const ShowIcon = nativewindWrapSvg(ShowIconRaw);
